import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { userFeatureKey, userReducer } from './user.reducer';
import { UserEffects } from './user.effects';

export const UserFeatureProviders = [
  provideState(userFeatureKey, userReducer),
  provideEffects(UserEffects),
];
